import { PageHeader } from "@/components/site/PageHeader";
import { TimelineSection } from "@/components/sections/TimelineSection";
import { StorySection } from "@/components/sections/StorySection";
import { IMAGES } from "@/lib/content";

export default function Journey() {
  return (
    <>
      <PageHeader label="The Journey" title="A REAL BUSINESS, BUILT IN PUBLIC" image={IMAGES.hero}>
        Every step from a few tanks around the house to — hopefully — a dedicated tropical fish business.
        No skipping the hard parts. No pretending it's further along than it is.
      </PageHeader>
      <TimelineSection />
      <StorySection />
    </>
  );
}
